import { Trans, useTranslation } from 'react-i18next';
import ResetPasswordFail from 'src/components/login/screens/ResetPasswordFail';
import { AccountType } from 'src/types';
import i18next from '../../../../i18n';
import { StyledLink } from '../ReportingForgotPassword/ReportingForgotPassword.styles';
import { ReportingResetFailContainer } from './ReportingResetFail.styles';

export const ReportingResetFail = () => {
  const { t } = useTranslation();
  return (
    <ReportingResetFailContainer>
      <ResetPasswordFail
        headerText={t('reporting.ReportingLogin.passwordFailTitle')}
        failText={
          <Trans
            i18n={i18next}
            i18nKey="reporting.ReportingLogin.passwordFailMessage"
            components={{
              mailto: (
                <StyledLink
                  href="mailto:techsupport@vaultplatform.com"
                  size="medium"
                  target="_blank"
                  rel="no-referrer"
                />
              ),
            }}
          />
        }
        kind={AccountType.App}
      />
    </ReportingResetFailContainer>
  );
};
